module.exports = __webpack_public_path__ + "static/media/user-avatar-2.0d84edf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/console-users/user-avatar-2.svg
// module id = 1468
// module chunks = 0